import * as yup from 'yup'

export const validationSchema = yup.object().shape({
  title: yup.string().required(),
  description: yup.string().required(),
  authorName: yup.string().required(),
  contactEmail: yup.string().email('Must be a valid email.').required(),
  artworkUrl: yup.string().required(),
  category: yup.string().required(),
})
